import e from "./index782.js";
import t from "./index783.js";
import a from "./index784.js";
import n from "./index785.js";
const f = function(r) {
  switch (r) {
    case "daterange":
    case "datetimerange":
      return t;
    case "monthrange":
      return a;
    case "yearrange":
      return n;
    default:
      return e;
  }
};
export {
  f as getPanel
};
